import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { branchOutcomes, ReconciliationDto, vehiclePresenceOutcomes } from "./reconciliation";
import { UsersService } from "src/app/users/users.service";
import { Users } from "county-api";
import { Store } from "@ngxs/store";
import { UserState } from "src/app/users/store/user.state";
import { MsalService } from "@azure/msal-angular";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { NotificationsService } from "src/app/universal/notifications/notifications.service";
import { BranchSchedule } from "../branch-day-fleet-site-check";

@Component({
    selector: 'reconciliation-new',
    templateUrl: './reconciliation-new.component.html',
    styleUrls: ['./reconciliation-new.component.scss']
})
export class ReconciliationNewComponent implements OnInit {

    loading = 0;

    schedules: BranchSchedule[] = [];

    reg = "";
    checkinDate = "";
    currentUser: Users.IUser | undefined;
    location = "";

    vehiclePresenceOutcome = "";
    keyOutcome = "";
    lockedOutcome = "";
    nonPresentialValue = "";

    presenceCheckType = "Vehicle-Presence-Check";
    vehicleKeyCheckType = "Vehicle-Key-Check";
    vehicleLockedCheckType = "Vehicle-Locked-Check";
    reconciliationType = "";
    displayableVehiclePresenceOutcomes: any[] = [];

    /**
     *
     */
    constructor(private route: ActivatedRoute,
        private store: Store,
        private authService: MsalService,
        private httpservice: HttpClient,
        private notification: NotificationsService,
        private router: Router
    ) {
       
        
    }
    
    ngOnInit(): void {
        const params = this.route.snapshot.queryParams;
        if (params.reg){
            this.reg = params.reg;
        }

        if (params.checkindate){
            this.checkinDate = params.checkindate;
        }

        if (params.location){
            this.location = params.location;
        }

        if (params.type){
            this.reconciliationType = params.type;
        }

        this.route.data.subscribe((data: { user: Users.IUser }) => {
            this.currentUser = this.store.selectSnapshot(UserState.user);                
        });

        this.loading++;
        this.downloadSchedules();
    }

    get latestLocation(){
        // on rent means on rent at current branch
        const noLocation = this.vehiclePresenceOutcome == "Missing" 
        || this.vehiclePresenceOutcome == "DirectorPersonalVehicle"
        || this.vehiclePresenceOutcome == "Defleeted";

        if (noLocation){
            return "";
        }


        else if (this.isPresenceOutcomeOnRentAtOtherBranch){
            const targetBranch = branchOutcomes.find(x => x.value === this.vehiclePresenceOutcome);
            if (targetBranch){
                return targetBranch.name;
            }

            return "";
        }

        return this.location;
    }

    getDisplayableVehiclePresenceOutcomes(){

        const filteredBranches = branchOutcomes
        .filter(x => x.value.indexOf(this.location) == -1); //filters out current branch from external branch list

        const presenceOutcomes = vehiclePresenceOutcomes.map(x => ({...x}));
        if(this.location.length > 0){
            var onRentOutcome = presenceOutcomes.find(x => x.value === "OnRent");

            if(onRentOutcome !== undefined){
                onRentOutcome.name = `On Rent at ${this.location}`; 
            }
            
        }
        
        return [...presenceOutcomes, ...filteredBranches];
    }

    get readableCheckinDate(){
        let selectedDate = this.checkinDate;
        if (!selectedDate ||selectedDate.length === 0){
            selectedDate = new Date().toDateString();
        }
        else{
            const date = this.parseUnixTime(selectedDate); //Conversion from unix time to js date
            selectedDate = date.toDateString();
        }
        return this.formatDateTime(selectedDate);
    }

    parseUnixTime(unixTimeString: string){
        return new Date(parseInt(unixTimeString) * 1000);
    }

    get submissionIsEnabled(){
        if (this.reconciliationType === this.presenceCheckType){
            return this.vehiclePresenceOutcome.length > 0;
        }
        else if(this.reconciliationType === this.vehicleKeyCheckType){
            return this.keyOutcome.length > 0;
        }
        else if(this.reconciliationType === this.vehicleLockedCheckType){
            return this.lockedOutcome.length > 0;
        }
    }

    //presence, key, locked outcomes will share the same value if they are not present
    // key and locked fields will disappear and special text fields will appear
    get isPresenceOutcomeOnRent(){
        return this.vehiclePresenceOutcome == "OnRent";
    }

    get isPresenceOutcomeWorkshop(){
        return this.vehiclePresenceOutcome == "AtWorkshop";
    }

    get isPresenceOutcomeNonRevenueMovement(){
        return this.vehiclePresenceOutcome == "NonRevenueMovement";
    }

    get isPresenceOutcomeMissing(){
        return this.vehiclePresenceOutcome == "Missing";
    }

    get isPresenceOutcomeOnRentAtOtherBranch(){
        return this.vehiclePresenceOutcome.startsWith("OnRentBranch");
    }

    get isPresenceOutcomeAtOtherBranch(){
        return this.vehiclePresenceOutcome.startsWith("Branch");
    }

    get vehicleNotPresent(){
        return this.isPresenceOutcomeOnRent || this.isPresenceOutcomeWorkshop || this.isPresenceOutcomeNonRevenueMovement || this.isPresenceOutcomeOnRentAtOtherBranch;
    }

    get isNonPresentialValueValid(){
        return (this.isPresenceOutcomeOnRent && this.isOnRentIdValid) ||
        (this.isPresenceOutcomeOnRentAtOtherBranch && this.isOnRentIdValid) ||
        (this.isPresenceOutcomeNonRevenueMovement && this.isNonRevenueMovementIdValid) ||
        (this.isPresenceOutcomeWorkshop && this.nonPresentialValue.trim().length > 4);
    }

    get isOnRentIdValid(){
        
        return this.nonPresentialValue.length > 2 &&
        this.isFirstNLetters(this.nonPresentialValue[0] + this.nonPresentialValue[1], 2) &&
        this.isFirstNDigitsNumeric(this.nonPresentialValue.slice(2), this.nonPresentialValue.length - 2);
    }

    get isNonRevenueMovementIdValid(){
        return this.nonPresentialValue.length > 2;
    }

    isFirstNDigitsNumeric(str, n) {
        const part = str.slice(0, n);
        return part.length === n && Number.isInteger(Number(part));
    }

    isFirstNLetters(str, n){ 
        return /^[A-Za-z]+$/.test(str.slice(0, n));
    }

    downloadSchedules() {
            const account = this.authService.instance.getAllAccounts()[0];
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
               };
    
            this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
                const accessToken = x.accessToken;

                const date: Date = this.parseUnixTime(this.checkinDate);
                
                this.retrieveActiveBranches(accessToken, date.getFullYear(), date.getMonth() + 1, date.getDate()).subscribe(
                        response => {
                            this.schedules = response.result as BranchSchedule[] ?? [];

                            this.displayableVehiclePresenceOutcomes = this.getDisplayableVehiclePresenceOutcomes();
                            this.loading--;
                        }
                );
            });  
        };

    submit(reconciliation: ReconciliationDto){
        this.loading++;
        const account = this.authService.instance.getAllAccounts()[0];
        const accessTokenRequest = {
            scopes: ["user.read"],
            account: account,
            };

        this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
            const accessToken = x.accessToken;

            this
            .postReconciliation(accessToken, reconciliation)
            .subscribe(x => {
                this.loading--;
                if (x && x.status_code){
                    this.notification.warn("Error during submission");
                }
                else{
                    this.notification.success("Reconciliation submitted");
                    this.redirectToOverview();
                }
            });
        });        
    }

    retrieveActiveBranches(accessToken: string, year: number, month: number, day: number){

        const url = environment.apiUrl + `api/v2/branchschedules/Active?year=${year}&month=${month}&day=${day}`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }

    postReconciliation(accessToken: string, reconciliation: ReconciliationDto){
    
            const url = environment.apiUrl + `api/v2/closingchecks/SubmitCheckReconciliation?type=${this.reconciliationType}`;
            const postObservable = this.httpservice.post<any>(
                url,
                reconciliation,
                {
                    headers: { 
                        "Authorization": accessToken,
                        'Accept': 'application/json', 
                    },
                    'responseType': 'json'
                },
            );
            return postObservable;
    }

    nullCollapse(value: string){
        if(!value){
            return null;
        }
    }

    createReconciliationDto(presenceOutcome: string, keyOutcome: string, lockedOutcome: string, nonPresentialValue?: string, branchOutcome?: string): ReconciliationDto{
        const currentDate = new Date();
        const dateString = currentDate.toISOString();

        const date = this.parseUnixTime(this.checkinDate);
        const checkinDateString = this.formatCheckinDateTime(date);

        const nonPresencialValueSuffix = nonPresentialValue == null || nonPresentialValue.length == 0 ? null : `${nonPresentialValue?.toUpperCase()}`;
        const branchValueSuffix = branchOutcome == null || branchOutcome.length == 0 ? null : `${branchOutcome}`;

        const suffixForPresence = nonPresentialValue == null || nonPresentialValue.length == 0 ? "" : `:${nonPresentialValue.toUpperCase()}`;
        
        let keyOutcomeValue = "";
        if(keyOutcome.length > 0){
            keyOutcomeValue = keyOutcome;
        }else{
            keyOutcomeValue = (this.nullCollapse(keyOutcome) ?? nonPresencialValueSuffix ?? branchValueSuffix ?? "");
        }

        return {
            Reg: this.reg,
            checkin_date: checkinDateString,
            location: this.location,
            vehicle_presence_check_reconciliation_outcome: presenceOutcome + suffixForPresence,
            vehicle_presence_check_reconciliation_date: dateString,
            vehicle_is_locked_check_reconciliation_by: this.currentUser?.username,
            vehicle_key_check_reconciliation_outcome:  keyOutcomeValue,
            vehicle_key_check_reconciliation_date: dateString,
            vehicle_key_check_reconciliation_by: this.currentUser?.username,
            vehicle_is_locked_check_reconciliation_outcome: (this.nullCollapse(lockedOutcome) ?? nonPresencialValueSuffix ?? branchValueSuffix ?? ""),
            vehicle_is_locked_check_reconciliation_date: dateString,
            vehicle_presence_check_reconciliation_by: this.currentUser?.username,
            check_type: "",
            created_date: ""
        };
    }

    formatCheckinDateTime(d: Date) {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
    }


    formatDateTime(date: string){
        const fmt = new Intl.DateTimeFormat("en-GB", {
            dateStyle: "full" 
        });

        return fmt.format(new Date(date));
    }

    submitReconciliation(){
        if (!this.submissionIsEnabled){
            this.notification.warn("Submission not enabled");
            return;
        }

        if ((this.isPresenceOutcomeOnRent || this.isPresenceOutcomeOnRentAtOtherBranch) && !this.isOnRentIdValid){
            this.notification.error("RA number is not valid");
            return;
        }

        else if (this.isPresenceOutcomeNonRevenueMovement && !this.isNonRevenueMovementIdValid){
            this.notification.error("Non Revenue Movement number is not valid");
            return;
        }

        else if (this.isPresenceOutcomeWorkshop && !this.isNonPresentialValueValid){
            this.notification.error("Workshop address is not valid");
            return;
        }

        var branchOutcome = this.isPresenceOutcomeOnRentAtOtherBranch ? this.vehiclePresenceOutcome : "";

        const reconciliation = this.createReconciliationDto(this.vehiclePresenceOutcome, this.keyOutcome, this.lockedOutcome, this.nonPresentialValue, branchOutcome);

        this.submit(reconciliation);
    }

    redirectToOverview(){
        const url = `site-checks`;

        this.router.navigateByUrl(url);
    }
    
}